
import { Card, CardBody, CardHeader, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row, Table, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import DatePicker from "react-datepicker";
import Swal from 'sweetalert2'
import Moment from 'moment'
import "react-datepicker/dist/react-datepicker.css";
import { useState } from "react";
import { Api } from "../../componentes/Api"
import * as moment from "moment";


    var Efectivo=0;
    var Credito=0;
    var Tarjeta=0;
    var Transferencia=0;
    var Cheque=0;
    var Total=0;
const HistorialVenta = () => {
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [buscarPor, setBuscarPor] = useState("fecha")
    const [ventas, setVentas] = useState([])


    const buscarVenta = async () => {
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' };

        let _fechaInicio = fechaInicio.toLocaleDateString('es-PE', options)
        let _fechaFin = fechaFin.toLocaleDateString('es-PE', options)

        let fi = moment(fechaInicio).format("YYYY-MM-DD");
        let ff = moment(fechaFin).format("YYYY-MM-DD");


      //  let response = await fetch(Api + `VentasTrans/HistorialFactura?buscarPor=${buscarPor}&fechaInicio=${_fechaInicio}&fechaFin=${_fechaFin}`)
        let response = await fetch(Api + "Pacientes/HistorialFactura/" + buscarPor + "/" + fi + "/" + ff)
            .then((response) => {
                return response.ok ? response.json() : Promise.reject(response);
            })
            .then((dataJson) => {
                var data = dataJson;
                if (data.length >= 1) {
                    setVentas(data);
                    Credito = data.reduce((x, y) => {
                        return x + y.credito;
                    }, 0)
                    Efectivo = data.reduce((x, y) => {
                        return x + y.efectivo;
                    }, 0)
                    Tarjeta = data.reduce((x, y) => {
                        return x + y.tarjeta;
                    }, 0)
                    Transferencia = data.reduce((x, y) => {
                        return x + y.transferencia;
                    }, 0)
                    Cheque = data.reduce((x, y) => {
                        return x + y.cheque;
                    }, 0)
                    Total = data.reduce((x, y) => {
                        return x + y.totalPago;
                    },0)
                } else { setVentas([]); }
            })}

    return (
        <>
            <Row>
                <Col sm={12}>
                    <Card>
                        <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                            Historial de ventas
                        </CardHeader>
                        <CardBody>
                            <Row className="align-items-end">
            <Col sm={3}>
                <FormGroup>
                    <Label>Fecha Inicio:</Label>
                    <DatePicker
                        className="form-control form-control-sm"
                        selected={fechaInicio}
                        onChange={(date) => setFechaInicio(date)}
                        dateFormat='dd/MM/yyyy'
                    />
                </FormGroup>
            </Col>

            <Col sm={3}>
                <FormGroup>
                    <Label>Fecha Fin:</Label>
                    <DatePicker
                        className="form-control form-control-sm"
                        selected={fechaFin}
                        onChange={(date) => setFechaFin(date)}
                        dateFormat='dd/MM/yyyy'
                    />
                </FormGroup>
            </Col>
            <Col sm={3}>
                <FormGroup>
                    <Button color="success" size="sm" block onClick={buscarVenta}>
                        <i className="fa fa-search" aria-hidden="true"></i> Buscar
                    </Button>
                </FormGroup>
            </Col>
           
                            </Row>
                            <hr></hr>
                    
                        <div class="summary">
                            <div class="summary-item">  Efectivo:<b>{Efectivo.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b> </div>
                            <div class="summary-item"> Credito:<b>{Credito.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b> </div>
                            <div class="summary-item">Tarjeta:<b> {Tarjeta.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                            <div class="summary-item">Transfe:<b>{Transferencia.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                            <div class="summary-item">  Cheque:<b>{Cheque.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                            <div class="summary-item">Total:<b>{Total.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                        </div>
                      <Row>
                                <Col sm="12">
                <Table striped responsive size="sm">
                    <thead>
                        <tr>
                          
                            <th>Numero Venta</th>
                            <th>Secuencia</th>
                            <th>Nombre Cliente</th>
                                                <th>Fecha Registro</th>
                                                <th>Cobertura</th>
                            <th>Total</th>
                          
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (ventas.length < 1) ? (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center" }}>
                                        Sin resultados
                                    </td>
                                </tr>
                            ) : (

                                ventas.map((item) => (
                                    <tr key={item.facturaID}>

                                        <td>{item.facturaID}</td>
                                        <td>{item.ncf}</td>
                                      
                                        <td>{item.nombreCliente}</td>

                                        <td>{moment(item.fecha).format("DD/MM/YYYY")}</td>
                                        <td style={{ textTransform: "uppercase" }}>{item.formaPago}</td>
                                        <td>{item.totalPago.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                        {/*<td>*/}
                                        {/*    <Button size="sm" color="info" outline*/}
                                        {/*        onClick={() => mostrarModal(item)}*/}
                                        {/*    >*/}
                                        {/*        <i className="fa fa-eye" aria-hidden="true"></i> Ver detalle*/}
                                        {/*    </Button>*/}
                                        {/*</td>*/}
                                    </tr>
                                ))
                            )
                        }
                    </tbody>
                </Table>

                                </Col>

                            </Row>

                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
        )

}
export default HistorialVenta;